import isEqual from 'lodash/isEqual';
import { SortType } from 'src/globals/constants';

export const isDefaultSortType = (sortType: string): boolean => {
  return isEqual(sortType, SortType.DEFAULT);
};
